export default "__VITE_ASSET__BUM8zUsE__"